import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Building Study Plan Animation',
    description:
      'A full-page animation with a progress bar that fills over a few seconds, then advances the student to their ACT/SAT study plan.',
    detail:
      'A transition, not a computation — the plan is already saved. The student is a moment from landing on it, so keep any reply brief and forward-looking.',
  });
};
